export enum CompanyProperties {
  isRestaurantEnabled = 'isRestaurantEnabled',
  tablesEnforced = 'tablesEnforced',
  isWebshopEnabled = 'isWebshopEnabled',
  isSelfOrderingEnabled = 'isSelfOrderingEnabled',
}
